'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('violation-code-list', {
      url: '/violation/code/list',
      template: '<violation-code-list></violation-code-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/violations/code-list/violations-code-list.routes.js